var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./Tips.svg": "./src/icons/svg/Tips.svg",
	"./addBtn.svg": "./src/icons/svg/addBtn.svg",
	"./addmaker.svg": "./src/icons/svg/addmaker.svg",
	"./areaSet.svg": "./src/icons/svg/areaSet.svg",
	"./article.svg": "./src/icons/svg/article.svg",
	"./back.svg": "./src/icons/svg/back.svg",
	"./bianji.svg": "./src/icons/svg/bianji.svg",
	"./bottom.svg": "./src/icons/svg/bottom.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./chakan.svg": "./src/icons/svg/chakan.svg",
	"./changeTurn.svg": "./src/icons/svg/changeTurn.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./close.svg": "./src/icons/svg/close.svg",
	"./codeicon.svg": "./src/icons/svg/codeicon.svg",
	"./columnManage.svg": "./src/icons/svg/columnManage.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./criticisms.svg": "./src/icons/svg/criticisms.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./del.svg": "./src/icons/svg/del.svg",
	"./deletBtn.svg": "./src/icons/svg/deletBtn.svg",
	"./det.svg": "./src/icons/svg/det.svg",
	"./dictionarySet.svg": "./src/icons/svg/dictionarySet.svg",
	"./dingwei.svg": "./src/icons/svg/dingwei.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./downLoaddd.svg": "./src/icons/svg/downLoaddd.svg",
	"./download.svg": "./src/icons/svg/download.svg",
	"./downloadBtn.svg": "./src/icons/svg/downloadBtn.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./editBtn.svg": "./src/icons/svg/editBtn.svg",
	"./editss.svg": "./src/icons/svg/editss.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./enter.svg": "./src/icons/svg/enter.svg",
	"./erweima.svg": "./src/icons/svg/erweima.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./fanhui.svg": "./src/icons/svg/fanhui.svg",
	"./favoriteYes.svg": "./src/icons/svg/favoriteYes.svg",
	"./file-pdf.svg": "./src/icons/svg/file-pdf.svg",
	"./flowmu.svg": "./src/icons/svg/flowmu.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fujian.svg": "./src/icons/svg/fujian.svg",
	"./getjifen.svg": "./src/icons/svg/getjifen.svg",
	"./guanlian.svg": "./src/icons/svg/guanlian.svg",
	"./guide 2.svg": "./src/icons/svg/guide 2.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./home.svg": "./src/icons/svg/home.svg",
	"./homeLine.svg": "./src/icons/svg/homeLine.svg",
	"./home_passcard.svg": "./src/icons/svg/home_passcard.svg",
	"./huifu.svg": "./src/icons/svg/huifu.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./ie.svg": "./src/icons/svg/ie.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./jiantou_you.svg": "./src/icons/svg/jiantou_you.svg",
	"./jiantou_zuo.svg": "./src/icons/svg/jiantou_zuo.svg",
	"./jifen.svg": "./src/icons/svg/jifen.svg",
	"./jifenduoge.svg": "./src/icons/svg/jifenduoge.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./logOut.svg": "./src/icons/svg/logOut.svg",
	"./menuIcon.svg": "./src/icons/svg/menuIcon.svg",
	"./menuSet.svg": "./src/icons/svg/menuSet.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./mima.svg": "./src/icons/svg/mima.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./muflow.svg": "./src/icons/svg/muflow.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./nodeicon.svg": "./src/icons/svg/nodeicon.svg",
	"./nothumbs-up.svg": "./src/icons/svg/nothumbs-up.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pen.svg": "./src/icons/svg/pen.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./perList.svg": "./src/icons/svg/perList.svg",
	"./phone.svg": "./src/icons/svg/phone.svg",
	"./pinlun.svg": "./src/icons/svg/pinlun.svg",
	"./preview.svg": "./src/icons/svg/preview.svg",
	"./pushu.svg": "./src/icons/svg/pushu.svg",
	"./puwen.svg": "./src/icons/svg/puwen.svg",
	"./puwenIcon.svg": "./src/icons/svg/puwenIcon.svg",
	"./puwen_icon.svg": "./src/icons/svg/puwen_icon.svg",
	"./puxi_icon.svg": "./src/icons/svg/puxi_icon.svg",
	"./puxiicon.svg": "./src/icons/svg/puxiicon.svg",
	"./pwd.svg": "./src/icons/svg/pwd.svg",
	"./qiandai.svg": "./src/icons/svg/qiandai.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./reading.svg": "./src/icons/svg/reading.svg",
	"./removes.svg": "./src/icons/svg/removes.svg",
	"./replymore.svg": "./src/icons/svg/replymore.svg",
	"./res.svg": "./src/icons/svg/res.svg",
	"./resourceSet.svg": "./src/icons/svg/resourceSet.svg",
	"./rili.svg": "./src/icons/svg/rili.svg",
	"./roleSet.svg": "./src/icons/svg/roleSet.svg",
	"./rolemod.svg": "./src/icons/svg/rolemod.svg",
	"./sanjiao.svg": "./src/icons/svg/sanjiao.svg",
	"./sanjiaoshang.svg": "./src/icons/svg/sanjiaoshang.svg",
	"./sanjiaoxia.svg": "./src/icons/svg/sanjiaoxia.svg",
	"./selection.svg": "./src/icons/svg/selection.svg",
	"./shijian.svg": "./src/icons/svg/shijian.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./shoucang.svg": "./src/icons/svg/shoucang.svg",
	"./shoucang_false.svg": "./src/icons/svg/shoucang_false.svg",
	"./shoucang_true.svg": "./src/icons/svg/shoucang_true.svg",
	"./shouru.svg": "./src/icons/svg/shouru.svg",
	"./shouzhiyou.svg": "./src/icons/svg/shouzhiyou.svg",
	"./shouzhizuo.svg": "./src/icons/svg/shouzhizuo.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./someClass.svg": "./src/icons/svg/someClass.svg",
	"./sousuo.svg": "./src/icons/svg/sousuo.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./stares.svg": "./src/icons/svg/stares.svg",
	"./surnameSet.svg": "./src/icons/svg/surnameSet.svg",
	"./sysSet.svg": "./src/icons/svg/sysSet.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./thumbs-up.svg": "./src/icons/svg/thumbs-up.svg",
	"./times.svg": "./src/icons/svg/times.svg",
	"./top.svg": "./src/icons/svg/top.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./txwb.svg": "./src/icons/svg/txwb.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./userRemove.svg": "./src/icons/svg/userRemove.svg",
	"./userSet.svg": "./src/icons/svg/userSet.svg",
	"./usercodeSmall.svg": "./src/icons/svg/usercodeSmall.svg",
	"./view.svg": "./src/icons/svg/view.svg",
	"./wb.svg": "./src/icons/svg/wb.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./wenjian.svg": "./src/icons/svg/wenjian.svg",
	"./weshare.svg": "./src/icons/svg/weshare.svg",
	"./wx.svg": "./src/icons/svg/wx.svg",
	"./wxicon.svg": "./src/icons/svg/wxicon.svg",
	"./xiaoxi.svg": "./src/icons/svg/xiaoxi.svg",
	"./xiazai.svg": "./src/icons/svg/xiazai.svg",
	"./xingxi.svg": "./src/icons/svg/xingxi.svg",
	"./yetu.svg": "./src/icons/svg/yetu.svg",
	"./you.svg": "./src/icons/svg/you.svg",
	"./yzm.svg": "./src/icons/svg/yzm.svg",
	"./zan.svg": "./src/icons/svg/zan.svg",
	"./zanzanzan.svg": "./src/icons/svg/zanzanzan.svg",
	"./zhichu.svg": "./src/icons/svg/zhichu.svg",
	"./zip.svg": "./src/icons/svg/zip.svg",
	"./zuo.svg": "./src/icons/svg/zuo.svg",
	"./单位管理.svg": "./src/icons/svg/单位管理.svg",
	"./权限.svg": "./src/icons/svg/权限.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";